import * as exFormat from '../format';

import type { TypeLanguageArgs, TypeLanguageRecord, TypeLanguageValue, TypeParsedLine } from './types';

// ----------------------------------------------------------------------------

function parseLine(line: string): TypeParsedLine {
    // ex: line => 'Language.hello.world'

    // ex: ['Language', 'hello', 'world']
    const splitted = line.split('.');
    // ex: 'Language'
    const file = splitted[0];
    // ex: 'hello.world'
    const parsedLine = line.slice(file.length + 1);

    //
    return { file, parsedLine };
}

function formatLanguageValue(message: TypeLanguageValue, args?: TypeLanguageArgs): TypeLanguageValue {
    if (args == null) {
        return message;
    }

    if (Array.isArray(message)) {
        return message.map((item: string): string => exFormat.replace(item, args));
    }

    if (typeof message === 'object') {
        const result: TypeLanguageRecord = {};

        for (const key of Object.keys(message)) {
            const value = message[key];
            result[key] = typeof value === 'undefined' ? value : formatLanguageValue(value, args);
        }

        return result;
    }

    return exFormat.replace(message, args);
}

function detectLocale(supportedLocales: string[], defaultLocale: string): string {
    const htmlLang = typeof document !== 'undefined' ? document.documentElement.lang?.trim() : '';

    if (htmlLang && supportedLocales.includes(htmlLang)) {
        return htmlLang;
    }

    // try base language code (e.g. 'pt' from 'pt-PT')
    const baseLang = htmlLang?.split('-')[0];
    if (baseLang && supportedLocales.includes(baseLang)) {
        return baseLang;
    }

    return defaultLocale;
}

// ----------------------------------------------------------------------------

export { detectLocale, formatLanguageValue, parseLine };
